<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Modelos</h1>
                                    <p class="modern-subtitle">Pesquise e baixe modelos de documentos por termo, tipo e categoria.</p>
                                </div>
                                <div class="header-actions">
                                    <ManualFerramenta :name="'Manual Modelos'"
                                                      :btnClass="'btn-manual-tool'"
                                                      :nameBtn="'Manual'"
                                                      :urlPdf="'/manuais/FERRAMENTA MODELO.pdf'" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-container">
                        <div class="search-card">
                            <div class="search-box">
                                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                <input type="text"
                                       class="modern-search-input"
                                       ref="dsTermo"
                                       placeholder="Pesquise por produto ou serviço…"
                                       aria-label="Pesquisa principal"
                                       v-model="pesquisa.dsTermo"
                                       @keydown.enter="buscar" />
                            </div>

                            <div class="filters-grid">
                                <div class="filter-group">
                                    <label class="filter-label" for="idModelo">Tipo de modelo</label>
                                    <select class="form-control" id="idModelo" v-model.number="pesquisa.idModelo">
                                        <option :value="0">Selecione</option>
                                        <option :value="item.idModelo" v-for="(item, index) in lstTipoModelo" :key="item.idModelo || index">
                                            {{ item.nmModelo }}
                                        </option>
                                    </select>
                                </div>

                                <div class="filter-group" v-if="lstCategoria.length > 0">
                                    <label class="filter-label" for="idModeloCategoria">Categoria</label>
                                    <select class="form-control" id="idModeloCategoria" v-model.number="pesquisa.idModeloCategoria">
                                        <option :value="0">Selecione</option>
                                        <option :value="item.idModeloCategoria" v-for="(item, index) in lstCategoria" :key="item.idModeloCategoria || index">
                                            {{ item.nmCategoria }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <button class="modern-btn modern-btn-primary btn-buscar" @click="buscar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                Buscar modelos
                            </button>
                        </div>

                        <div class="results-section">
                            <div class="results-header">
                                <h2 class="results-title">Modelos</h2>
                                <span class="results-query" v-if="flResultados">
                                    {{ rotuloPesquisa }}
                                </span>
                            </div>

                            <Grid url_ajax="/Modelo/CarregaModeloArquivo"
                                  :is_table="false"
                                  :reload="reload"
                                  :ajax_set_result="setModelos"
                                  :ajax_set_count="setCount"
                                  :data_ajax="getDataAjax()"
                                  :qtd_registros_por_pagina="20">
                                <template v-slot:rows="{ rows }">
                                    <div v-if="rows.length === 0 && flResultados" class="empty-state empty-state--compact">
                                        <div class="empty-content">
                                            <h3 class="empty-title">Nenhum modelo encontrado</h3>
                                            <p class="empty-description">Ajuste os filtros ou informe outro termo para pesquisa.</p>
                                        </div>
                                    </div>

                                    <div v-else-if="rows.length > 0" class="cards-list">
                                        <div class="result-card"
                                             v-for="(item, index) in rows"
                                             :key="item.modeloArquivo && item.modeloArquivo.idModeloArquivo || index">
                                            <div class="result-card__body">
                                                <div class="result-card__meta">
                                                    <span class="result-card__icon"
                                                          :class="`result-card__icon--${getFileType(item.modeloArquivo && item.modeloArquivo.urlArquivo)}`"
                                                          aria-hidden="true">
                                                        <i :class="getFileIcon(item.modeloArquivo && item.modeloArquivo.urlArquivo)"></i>
                                                    </span>
                                                    <span class="result-badge" :class="`result-badge--${getFileType(item.modeloArquivo && item.modeloArquivo.urlArquivo)}`">
                                                        {{ getFileLabel(item.modeloArquivo && item.modeloArquivo.urlArquivo) }}
                                                    </span>
                                                    <span class="result-chip" v-if="item.flNovo">Novo</span>
                                                </div>
                                                <h3 class="result-card__title">{{ item.modeloArquivo && item.modeloArquivo.nmArquivo }}</h3>
                                                <p class="result-card__text">
                                                    {{ item.modeloArquivo && item.modeloArquivo.nmModelo }}
                                                    <template v-if="item.modeloArquivo && item.modeloArquivo.nmCategoria">
                                                        ({{ item.modeloArquivo.nmCategoria }})
                                                    </template>
                                                </p>
                                            </div>

                                            <div class="result-card__actions">
                                                <button class="modern-btn modern-btn-secondary"
                                                        type="button"
                                                        :disabled="!isPdf(item.modeloArquivo && item.modeloArquivo.urlArquivo) || flBaixando"
                                                        @click.stop="visualizar(item.modeloArquivo)">
                                                    <i class="fas fa-eye"></i>
                                                    Visualizar
                                                </button>
                                                <button class="modern-btn modern-btn-primary"
                                                        type="button"
                                                        :disabled="flBaixando"
                                                        @click.stop="linkDownload(item.modeloArquivo)">
                                                    <i class="fas fa-download"></i>
                                                    Download
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modais></Modais>

        <div class="modal fade modal-modelo-pdf" tabindex="-1" id="ModalModeloPdf" ref="modalModeloPdf">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0 bg-transparent">
                    <div class="md-wrapper" v-if="modeloSelecionado">
                        <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                                type="button"
                                aria-label="Fechar"
                                @click="fecharPdf">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>

                        <div class="md-header">
                            <div class="md-header__id">
                                <span class="md-header__badge">
                                    <i class="fas fa-file-pdf"></i>
                                    PDF
                                </span>
                                <h2 class="md-header__title">{{ modeloSelecionado.nmArquivo }}</h2>
                            </div>
                        </div>

                        <div class="md-body">
                            <div class="md-loading" v-if="flCarregandoPdf">
                                <div class="md-loading__spinner"></div>
                                <span>Carregando arquivo…</span>
                            </div>
                            <iframe v-else-if="urlPdfBlob"
                                    class="md-pdf-frame"
                                    :src="urlPdfBlob"
                                    title="Visualização do modelo"></iframe>
                            <div class="md-notfound" v-else>
                                <strong>Não foi possível exibir o arquivo</strong>
                                <p>Tente novamente ou faça o download do modelo.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import axios from 'axios'
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import Grid from '@/components/Ferramentas/Grid'
    import { urlApi, avisoErro } from '@/config/global'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'


    export default defineComponent({
        name: 'Modelos',
        components: {
            Header,
            Modais,
            Grid,
            ManualFerramenta
        },

        data() {
            return {
                pesquisa: {
                    dsTermo: '',
                    idModelo: 0,
                    idModeloCategoria: 0,
                },
                lstTipoModelo: [],
                lstCategoria: [],
                flResultados: false,
                flBaixando: false,
                flCarregandoPdf: false,
                modeloSelecionado: null,
                urlPdfBlob: '',
                modalModeloPdf: null,
                reload: 0,
                dataAjax: null,
            }
        },

        computed: {
            rotuloPesquisa() {
                const termo = this.dataAjax && this.dataAjax.termo
                if (termo) {
                    return `"${termo}"`
                }
                return 'Todos os modelos'
            },
        },

        methods: {
            load() {
                this.carregaTiposModelo()
                this.buscar()
            },

            carregaTiposModelo() {
                axios.get(`${urlApi}/Modelo/CarregaModelo`)
                    .then((res) => {
                        if (res.data?.success) {
                            this.lstTipoModelo = res.data.data || []
                        } else {
                            avisoErro('Não foi possível carregar os tipos de modelo')
                        }
                    })
                    .catch((error) => {
                        if (error.response?.data != undefined) {
                            avisoErro(error.response.data)
                        } else {
                            avisoErro('Não foi possível carregar os tipos de modelo')
                        }
                    })
            },

            carregaModeloCategoria() {
                this.lstCategoria = []
                if (!this.pesquisa.idModelo) {
                    return
                }

                axios.get(`${urlApi}/Modelo/CarregaModeloCategoria`, { params: { idModelo: this.pesquisa.idModelo } })
                    .then((res) => {
                        if (res.data?.success) {
                            this.lstCategoria = res.data.data || []
                        } else {
                            avisoErro('Não foi possível carregar as categorias')
                        }
                    })
                    .catch((error) => {
                        if (error.response?.data != undefined) {
                            avisoErro(error.response.data)
                        } else {
                            avisoErro('Não foi possível carregar as categorias')
                        }
                    })
            },

            buscar() {
                this.dataAjax = {
                    termo: this.pesquisa.dsTermo || '',
                    idModelo: this.pesquisa.idModelo || 0,
                    idModeloCategoria: this.pesquisa.idModeloCategoria || 0,
                }
                this.reload += 1
            },

            setModelos(data) {
                if (this.flResultados) {
                    window.scrollTo({ top: 400, behavior: 'smooth' })
                }
                this.flResultados = true
                return data?.rows || []
            },

            setCount(resData) {
                return resData?.data?.qtdRecords || 0
            },

            getDataAjax() {
                return this.dataAjax
            },

            getFileType(url) {
                const arquivo = (url || '').toLowerCase()
                if (arquivo.includes('.pdf')) return 'pdf'
                if (arquivo.includes('.doc') || arquivo.includes('.docx') || arquivo.includes('.rtf')) return 'word'
                if (arquivo.includes('.xls') || arquivo.includes('.xlsx')) return 'excel'
                if (arquivo.includes('.png') || arquivo.includes('.jpg') || arquivo.includes('.jpeg')) return 'img'
                return 'file'
            },

            getFileIcon(url) {
                const tipo = this.getFileType(url)
                if (tipo === 'pdf') return 'fas fa-file-pdf'
                if (tipo === 'word') return 'fas fa-file-word'
                if (tipo === 'excel') return 'fas fa-file-excel'
                if (tipo === 'img') return 'fas fa-file-image'
                return 'fas fa-file'
            },

            getFileLabel(url) {
                const tipo = this.getFileType(url)
                if (tipo === 'pdf') return 'PDF'
                if (tipo === 'word') return 'Word'
                if (tipo === 'excel') return 'Excel'
                if (tipo === 'img') return 'Imagem'
                return 'Arquivo'
            },

            isPdf(url) {
                return this.getFileType(url) === 'pdf'
            },

            getDownloadName(modeloArquivo) {
                const arquivo = (modeloArquivo && modeloArquivo.urlArquivo || '').toLowerCase()
                const nome = (modeloArquivo && modeloArquivo.nmArquivo) || 'modelo'
                if (arquivo.includes('.pdf')) return `${nome}.pdf`
                if (arquivo.includes('.doc') || arquivo.includes('.docx')) return `${nome}.docx`
                if (arquivo.includes('.png') || arquivo.includes('.jpg') || arquivo.includes('.jpeg')) return `${nome}.png`
                if (arquivo.includes('.xls') || arquivo.includes('.xlsx')) return `${nome}.xlsx`
                if (arquivo.includes('.rtf')) return `${nome}.rtf`
                const partes = (modeloArquivo && modeloArquivo.urlArquivo || '').split('/')
                return partes.length >= 7 ? partes[6] : nome
            },

            urlDownload(modeloArquivo, nmArquivo) {
                const urlArquivo = encodeURIComponent(modeloArquivo.urlArquivo || '')
                const arquivo = encodeURIComponent(nmArquivo || '')
                return `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${arquivo}`
            },

            liberarPdfBlob() {
                if (this.urlPdfBlob) {
                    window.URL.revokeObjectURL(this.urlPdfBlob)
                    this.urlPdfBlob = ''
                }
            },

            fecharPdf() {
                this.modalModeloPdf?.hide()
            },

            visualizar(modeloArquivo) {
                if (!modeloArquivo || !this.isPdf(modeloArquivo.urlArquivo)) {
                    return
                }

                this.modeloSelecionado = modeloArquivo
                this.flCarregandoPdf = true
                this.liberarPdfBlob()

                this.$nextTick(() => {
                    if (!this.modalModeloPdf && this.$refs.modalModeloPdf) {
                        this.modalModeloPdf = new window.bootstrap.Modal(this.$refs.modalModeloPdf)
                    }
                    this.modalModeloPdf?.show()
                    this.carregarPdf(modeloArquivo)
                })
            },

            async carregarPdf(modeloArquivo) {
                const nmArquivo = this.getDownloadName(modeloArquivo)
                
                try {
                    const response = await axios({
                        url: this.urlDownload(modeloArquivo, nmArquivo),
                        method: 'GET',
                        responseType: 'blob',
                    })

                    if (this.modeloSelecionado !== modeloArquivo) {
                        return
                    }

                    this.liberarPdfBlob()
                    this.urlPdfBlob = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
                    axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'SC_VIS_MOD' }, { showLoading: false }).catch(() => { })
                } catch (error) {
                    if (this.modeloSelecionado !== modeloArquivo) {
                        return
                    }
                    if (error.response?.data != undefined && typeof error.response.data === 'string') {
                        avisoErro(error.response.data)
                    } else {
                        avisoErro('Não foi possível visualizar o arquivo')
                    }
                } finally {
                    if (this.modeloSelecionado === modeloArquivo) {
                        this.flCarregandoPdf = false
                    }
                }
            },

            async linkDownload(modeloArquivo) {
                if (!modeloArquivo || !modeloArquivo.urlArquivo || this.flBaixando) {
                    return
                }

                const nmArquivo = this.getDownloadName(modeloArquivo)
                this.flBaixando = true

                try {
                    const response = await axios({
                        url: this.urlDownload(modeloArquivo, nmArquivo),
                        method: 'GET',
                        responseType: 'blob',
                    })

                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', nmArquivo)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)

                    axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'SC_DWN_MOD' }, { showLoading: false }).catch(() => { })
                } catch (error) {
                    if (error.response?.data != undefined && typeof error.response.data === 'string') {
                        avisoErro(error.response.data)
                    } else {
                        avisoErro('Não foi possível baixar o arquivo')
                    }
                } finally {
                    this.flBaixando = false
                }
            },
        },

        mounted() {
            this.load()

            const el = this.$refs.modalModeloPdf
            if (el) {
                el.addEventListener('hidden.bs.modal', () => {
                    this.liberarPdfBlob()
                    this.modeloSelecionado = null
                    this.flCarregandoPdf = false
                })
            }
        },

        beforeDestroy() {
            this.liberarPdfBlob()
        },

        watch: {
            'pesquisa.idModelo'() {
                this.pesquisa.idModeloCategoria = 0
                this.carregaModeloCategoria()
            },
        },
    })
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 820px;
        min-width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .page-container {
        max-width: 1140px;
        margin: 0 auto;
        padding: 24px 16px 48px;
    }

    .search-card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 1px solid rgba(31, 123, 255, 0.1);
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        padding: 24px;
        margin-bottom: 28px;
    }

    [data-bs-theme="dark"] .search-card {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .search-box {
        position: relative;
        margin-bottom: 20px;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    .filters-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        align-items: end;
        margin-bottom: 20px;
    }

    .filter-label {
        display: block;
        font-size: 12px;
        font-weight: 700;
        color: #6b7280;
        letter-spacing: .04em;
        text-transform: uppercase;
        margin-bottom: 6px;
    }

    .form-control {
        border-radius: 10px;
        border: 2px solid #e5e7eb;
        background-color: #ffffff;
        padding: 10px 14px;
        font-size: 14px;
        color: #1f2937;
        min-height: 42px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .form-control:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        background-color: #ffffff;
    }

    [data-bs-theme="dark"] .form-control {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    select.form-control {
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
    }

    .modern-btn:disabled {
        opacity: .55;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover:not(:disabled) {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
    }

    .modern-btn-secondary {
        background: #fff;
        color: #1d4ed8;
        border: 1px solid rgba(37, 99, 235, 0.35);
    }

    .modern-btn-secondary:hover:not(:disabled) {
        background: rgba(37, 99, 235, 0.06);
        transform: translateY(-2px);
    }

    [data-bs-theme="dark"] .modern-btn-secondary {
        background: #111827;
        color: #93c5fd;
        border-color: #374151;
    }

    .btn-buscar {
        width: 100%;
    }

    .results-header {
        display: flex;
        align-items: baseline;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .results-header {
        border-bottom-color: #374151;
    }

    .results-title {
        font-size: 20px;
        font-weight: 800;
        color: #1f2937;
        margin: 0;
        letter-spacing: -0.3px;
    }

    [data-bs-theme="dark"] .results-title {
        color: #f9fafb;
    }

    .results-query {
        font-size: 14px;
        font-weight: 600;
        color: #2563eb;
    }

    .empty-state {
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        border: 1px dashed #e5e7eb;
        border-radius: 12px;
        padding: 64px 24px;
        text-align: center;
    }

    .empty-state--compact {
        padding: 40px 24px;
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-title {
        font-size: 20px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 15px;
        color: #6b7280;
        margin: 0;
        max-width: 460px;
        line-height: 1.6;
    }

    .cards-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .result-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        background: #fff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        padding: 18px 20px;
        transition: transform .2s, box-shadow .2s, border-color .2s;
    }

    .result-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.12);
        border-color: rgba(37, 99, 235, 0.35);
    }

    [data-bs-theme="dark"] .result-card {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    .result-card__body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 0;
        width: 100%;
    }

    .result-card__meta {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        flex-wrap: wrap;
    }

    .result-card__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 8px;
        background: #f3f4f6;
        color: #4b5563;
        flex-shrink: 0;
        font-size: 14px;
    }

    .result-card__icon--pdf {
        background: rgba(220, 53, 69, 0.12);
        color: #dc3545;
    }

    .result-card__icon--word {
        background: rgba(0, 123, 255, 0.12);
        color: #007BFF;
    }

    .result-card__icon--excel {
        background: rgba(40, 167, 69, 0.12);
        color: #28a745;
    }

    .result-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        background: #fff;
        color: #4b5563;
        border: 1px solid #767676;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        padding: 4px 12px;
        border-radius: 6px;
        line-height: 1.2;
    }

    .result-badge--pdf {
        background: #fff;
        border-color: #dc3545;
        color: #dc3545;
    }

    .result-badge--word {
        background: #fff;
        border-color: #007BFF;
        color: #007BFF;
    }

    .result-badge--excel {
        background: #fff;
        border-color: #28a745;
        color: #28a745;
    }

    .result-badge--img,
    .result-badge--file {
        background: #fff;
        border-color: #767676;
        color: #767676;
    }

    [data-bs-theme="dark"] .result-card__icon {
        background: #111827;
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .result-card__icon--pdf {
        background: rgba(220, 53, 69, 0.18);
        color: #f87171;
    }

    [data-bs-theme="dark"] .result-card__icon--word {
        background: rgba(0, 123, 255, 0.18);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .result-badge {
        background: #111827;
        border-color: #6b7280;
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .result-badge--pdf {
        background: #111827;
        border-color: #dc3545;
        color: #f87171;
    }

    [data-bs-theme="dark"] .result-badge--word {
        background: #111827;
        border-color: #007BFF;
        color: #60a5fa;
    }

    .result-chip {
        display: inline-flex;
        width: fit-content;
        font-size: 12px;
        font-weight: 700;
        color: #1d4ed8;
        background: rgba(37, 99, 235, 0.1);
        padding: 4px 10px;
        border-radius: 20px;
        text-transform: uppercase;
        letter-spacing: .04em;
    }

    [data-bs-theme="dark"] .result-chip {
        background: #111827;
        color: #93c5fd;
    }

    .result-card__title {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
        line-height: 1.35;
    }

    [data-bs-theme="dark"] .result-card__title {
        color: #f9fafb;
    }

    .result-card__text {
        font-size: 13px;
        color: #6b7280;
        line-height: 1.6;
        margin: 0;
    }

    [data-bs-theme="dark"] .result-card__text {
        color: #9ca3af;
    }

    .result-card__actions {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
    }

    :deep(.grid-app .btn-navegacao) {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
        border: none !important;
        border-radius: 10px !important;
        font-weight: 600;
        padding: 8px 16px;
        color: #fff !important;
    }

    .md-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: calc(100vh - 72px);
        overflow: visible;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 24px 80px rgba(15, 23, 42, 0.28);
    }

    .btn-close-modern {
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.05);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .md-header {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: none;
        min-height: 66px;
        padding: 12px 24px;
        background: #fff;
        border-bottom: 1px solid #e5e7eb;
        border-radius: 16px 16px 0 0;
    }

    .md-header__id {
        display: flex;
        align-items: center;
        gap: 14px;
        flex: 1;
        min-width: 0;
    }

    .md-header__badge {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        flex: none;
        padding: 5px 10px;
        border: 1px solid rgba(185, 28, 28, 0.2);
        border-radius: 7px;
        background: rgba(220, 53, 69, 0.08);
        color: #b91c1c;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.13em;
        text-transform: uppercase;
    }

    .md-header__title {
        margin: 0;
        font-size: 17px;
        font-weight: 700;
        color: #1f2937;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .md-body {
        flex: 1 1 auto;
        overflow: hidden;
        background: #f8fafc;
        border-radius: 0 0 16px 16px;
        min-height: 520px;
        max-height: calc(100vh - 72px - 66px);
    }

    .md-pdf-frame {
        width: 100%;
        height: calc(100vh - 72px - 66px);
        min-height: 520px;
        border: 0;
        background: #525659;
    }

    .md-loading,
    .md-notfound {
        display: grid;
        place-items: center;
        gap: 12px;
        min-height: 320px;
        padding: 40px 24px;
        color: #6b7280;
        font-size: 14.5px;
        text-align: center;
    }

    .md-notfound strong {
        font-size: 19px;
        font-weight: 700;
        color: #1f2937;
    }

    .md-loading__spinner {
        width: 38px;
        height: 38px;
        border: 3px solid #e5e7eb;
        border-top-color: #2563eb;
        border-radius: 50%;
        animation: mdSpin 0.7s linear infinite;
    }

    @keyframes mdSpin {
        to { transform: rotate(360deg); }
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }

    @media (max-width: 991px) {
        .filters-grid {
            grid-template-columns: 1fr;
        }

        .result-card {
            flex-direction: column;
            align-items: stretch;
        }

        .result-card__actions {
            width: 100%;
        }

        .result-card__actions .modern-btn {
            flex: 1;
        }
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .title-section {
            max-width: 100%;
        }

        .modern-title {
            font-size: 24px;
        }

        .md-wrapper { max-height: calc(100vh - 32px); }

        .md-header {
            padding: 14px 16px;
        }

        .md-header__title {
            white-space: normal;
            font-size: 16px;
        }
    }

    @media (max-width: 575px) {
        .search-card {
            padding: 16px;
        }
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    :deep(.btn-manual-tool) {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        min-height: 42px;
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
        color: #fff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.btn-manual-tool:hover) {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%) !important;
        transform: translateY(-2px);
    }
</style>

<style lang="scss">
    .modal-modelo-pdf.modal {
        overflow: visible;
    }

    .modal-modelo-pdf .modal-dialog {
        width: 90%;
        max-width: 90vw;
        overflow: visible;
        margin: 36px auto;
    }

    .modal-modelo-pdf .modal-content {
        background: transparent;
        border: 0;
        box-shadow: none;
        overflow: visible;
    }
</style>
